import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import withStyles from 'isomorphic-style-loader/withStyles';

import {
  Label,
  Checkbox,
  MenuItem,
  DropdownButton,
  ButtonGroup,
  ButtonToolbar,
  Button,
} from 'react-bootstrap';

import Tooltip from '../Tooltip';

import s from './GeneNetworkToolbar.css';

/*
 * UI component for a network toolbar
 */

class GeneNetworkToolbar extends Component {
  static propTypes = {
    // Genesets to highlight in the network
    geneSets: PropTypes.object.isRequired,

    // Called when a geneset is removed via the dropdown menu
    onGeneSetRemove: PropTypes.func.isRequired,

    onLock: PropTypes.func.isRequired,

    onZoomOut: PropTypes.func.isRequired,

    onZoomIn: PropTypes.func.isRequired,

    onFitZoom: PropTypes.func.isRequired,
    onExpand: PropTypes.func,

    onInnerLayout: PropTypes.func.isRequired,
    onOuterLayout: PropTypes.func.isRequired,

    onSaveImage: PropTypes.func,
    onSaveTextFull: PropTypes.func,
    onSaveText: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      locked: true,
      outerLayout: false,
      innerLayout: false,
      expandView: false,
    };
  }

  render() {
    const genesetMenu = (gs, idx) => (
      <MenuItem key={gs} eventKey={idx + 1}>
        <Label
          onClick={() => this.props.onGeneSetRemove(this.props.geneSets[gs])}
          style={{ background: this.props.geneSets[gs].color }}
        >
          {this.props.geneSets[gs].title} |{' '}
          <i className="fa fa-times fa-inverse fa-lg" />
        </Label>
      </MenuItem>
    );
    return (
      <div
        className={s.root}
        style={{ ...this.props.style, backgroundColor: 'white' }}
      >
        <ButtonGroup>
          <Tooltip placement="top" text="Download network">
            <DropdownButton
              bsStyle="link"
              className={s.button}
              id="download network"
              title={<i className="fa fa-download" />}
            >
              {this.props.onSaveImage && (
                <MenuItem onClick={this.props.onSaveImage}>
                  <i className="fa fa-file-image-o" /> Save network as image
                </MenuItem>
              )}
              {this.props.onSaveText && (
                <MenuItem onClick={this.props.onSaveText}>
                  <i className="fa fa-file-text-o" /> Save network as text
                  (visible)
                </MenuItem>
              )}
              {this.props.onSaveTextFull && (
                <MenuItem onClick={this.props.onSaveTextFull}>
                  <i className="fa fa-file-text-o" /> Save network as text
                  (entire)
                </MenuItem>
              )}
            </DropdownButton>
          </Tooltip>
        </ButtonGroup>
        <ButtonGroup>
          <Tooltip placement="top" text="Starred process or tissue genesets">
            <DropdownButton
              bsStyle="link"
              className={s.button}
              id="starred"
              disabled={!Object.keys(this.props.geneSets).length}
              title={<i className="fa fa-star" />}
            >
              {Object.keys(this.props.geneSets).map(genesetMenu)}
            </DropdownButton>
          </Tooltip>
        </ButtonGroup>
        <ButtonGroup>
          <Tooltip
            placement="top"
            text="Layout with the query genes on the periphery"
          >
            <Button
              bsStyle={!this.state.outerLayout ? 'link' : 'default'}
              className={s.button}
              active={this.state.outerLayout}
              onClick={() => {
                const innerLayout = this.state.outerLayout
                  ? this.state.innerLayout
                  : this.state.outerLayout;
                this.props.onOuterLayout(innerLayout, !this.state.outerLayout);
                this.setState({
                  outerLayout: !this.state.outerLayout,
                  innerLayout,
                });
              }}
            >
              <i className="fa fa-circle-o" />
            </Button>
          </Tooltip>
          <Tooltip
            placement="top"
            text="Layout with the query genes in the center"
          >
            <Button
              bsStyle={!this.state.innerLayout ? 'link' : 'default'}
              className={s.button}
              active={this.state.innerLayout}
              onClick={() => {
                const outerLayout = this.state.innerLayout
                  ? this.state.outerLayout
                  : this.state.innerLayout;
                this.props.onInnerLayout(!this.state.innerLayout, outerLayout);
                this.setState({
                  outerLayout,
                  innerLayout: !this.state.innerLayout,
                });
              }}
            >
              <i className="fa fa-dot-circle-o" />
            </Button>
          </Tooltip>
        </ButtonGroup>
        <ButtonGroup>
          <Tooltip
            placement="top"
            text={`${this.state.locked ? 'Unlock' : 'Lock'} the layout`}
          >
            <Button
              bsStyle={!this.state.locked ? 'link' : 'default'}
              className={s.button}
              id="lock"
              active={this.state.locked}
              onClick={() => {
                this.props.onLock(!this.state.locked);
                this.setState({ locked: !this.state.locked });
              }}
            >
              <i
                className={this.state.locked ? 'fa fa-unlock' : 'fa fa-lock'}
              />
            </Button>
          </Tooltip>
          <Tooltip placement="top" text="Zoom out">
            <Button
              bsStyle="link"
              className={s.button}
              onClick={this.props.onZoomOut}
            >
              <i className="fa fa-search-minus" />
            </Button>
          </Tooltip>
          <Tooltip placement="top" text="Zoom in">
            <Button
              bsStyle="link"
              className={s.button}
              onClick={this.props.onZoomIn}
            >
              <i className="fa fa-search-plus" />
            </Button>
          </Tooltip>
          {this.props.onExpand && (
            <Tooltip
              placement="top"
              text={this.state.expandView ? 'Shrink view' : 'Expand view'}
            >
              <Button
                id="expand"
                bsStyle={!this.state.expandView ? 'link' : 'default'}
                className={s.button}
                active={this.state.expandView}
                onClick={() => {
                  this.setState({ expandView: !this.state.expandView });
                  this.props.onExpand(!this.state.expandView);
                }}
              >
                <i
                  className={
                    this.state.expandView ? 'fa fa-compress' : 'fa fa-expand'
                  }
                />
              </Button>
            </Tooltip>
          )}
          <Tooltip placement="top" text="Auto re-size">
            <Button
              bsStyle="link"
              className={s.button}
              onClick={this.props.onFitZoom}
            >
              <i className="fa fa-arrows-alt" />
            </Button>
          </Tooltip>
        </ButtonGroup>
      </div>
    );
  }
}

export default withStyles(s)(GeneNetworkToolbar);
